export type ParsedGiftCard = {
  title: string
  amount: string
  recipientEmail: string
  categories: string[]
  productId: string
  giftUrl: string
}

export function parseGiftCardData(raw: unknown): ParsedGiftCard {
  const data =
    raw && typeof raw === 'object' ? (raw as Record<string, unknown>) : {}

  const categoriesRaw = data.Category ?? data.category
  const categories = Array.isArray(categoriesRaw)
    ? categoriesRaw.map((c) => String(c)).filter(Boolean)
    : []

  const amountRaw = data.Amount ?? data.amount ?? data.value
  const amountNum = Number(amountRaw)
  const amount =
    Number.isFinite(amountNum) && amountNum !== 0 ? `$${amountNum.toFixed(2)}` : '—'

  return {
    title: String(
      data.Title ?? data.title ?? data.ProductName ?? data.productName ?? data.name ?? '—'
    ),
    amount,
    recipientEmail: String(data.RecipientEmail ?? data.recipientEmail ?? '—'),
    categories,
    productId: String(data.ProductId ?? data.productId ?? data.SKU ?? '—'),
    giftUrl: String(data.GiftURL ?? data.gift_url ?? data.GiftUrl ?? ''),
  }
}
